<template>
  <section class="mbs-wrap mbs009">
        <div class="mbs-inner clear">
            <LoginLeft/>
            <div class="mbs-right">
                <div class="tit">{{ $i18nUtil.trans("title.Join.001", "업무공유시스템 회원가입") }}</div>
                <fieldset>
                    <div class="input-box">
                        <input autocomplete="new-password" type="text" id="userName" name="userName" v-model="userName" v-validate="'required'" readonly/>
                        <!-- <div class="error-list">
                            <div class="error" v-if="errors.has('userName')">이름을 입력해주세요.</div>
                        </div> -->
                    </div>
                    <div class="input-box">
                        <input autocomplete="new-password" type="email" id="email" name="email" v-model="email" v-validate="'required'" readonly/>
                        <!-- <div class="error-list"> -->
                            <div class="error" v-if="errors.has('email')">{{ $i18nUtil.trans("message.Join.001", "* 이메일을 입력해주세요.") }}</div>
                        <!-- </div> -->
                    </div>
                    <div class="input-box" id="partnerArea">
                        <!-- <input autocomplete="new-password" type="text" id="partnerName" name="partnerName" v-model="partnerName" v-validate="'required'" @click="hidePartnerList" placeholder="소속회사"/> -->
                        <input autocomplete="new-password" type="text" id="partnerName" name="partnerName" v-model="partnerName" v-validate="'required'" @input="getPartnerList($event)" :placeholder="$i18nUtil.trans('message.Join.002', '소속회사 (최대15자)')"/>
                        <!-- <div class="error-list"> -->
                            <div class="error" v-if="errors.has('partnerName')">{{ $i18nUtil.trans("message.Join.003", "* 소속회사를 선택해주세요.") }}</div>
                        <!-- </div> -->
                        <!-- <div class="scroll-box" > -->
                        <div class="scroll-box" v-if="show">
                            <ul>
                                <li v-for="(item, index) in partnerList" :key="'partner' + index">
                                    <button type="button" @click="selectPartner(item)">{{item}}</button>
                                </li>
                            </ul>
                            <button type="button" class="add-box" @click="addPartner">{{ $i18nUtil.trans("button.Join.addPartner", "{partner} 신규추가", {partner: partnerName}) }}</button>
                        </div>
                    </div>
                    <div class="input-box" style="min-height: 72px;">
                        <input autocomplete="new-password" type="password" id="password" name="password" v-model="password" ref="pw" @keyup="passWordValidation" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.password', '비밀번호')" maxlength="10">
                        <!-- <div class="error-list"> -->
                            <!-- <div class="error" v-show="errors.has('password') ">비밀번호를 입력하세요.</div> -->
                            <div class="error" v-if="errors.has('password')">{{ $i18nUtil.trans("message.password.valid.error.001", "* 비밀번호를 입력하세요.") }}</div>
                            <div class="error" v-if="validStep2 === false">{{ $i18nUtil.trans("message.password.valid.error.002", "* 영문/숫자/특수문자 조합하여 8~10자") }}</div>
                            <div class="error" v-if="validStep3 === false">{{ $i18nUtil.trans("message.password.valid.error.003", "* 기존 비밀번호와 동일한 설정 제외") }}</div>
                            <div class="error" v-if="validStep4 === false">{{ $i18nUtil.trans("message.password.valid.error.004", "* 전화번호와 동일한 설정 제외") }}</div>
                            <div class="normal" v-if="isValidPassword === true">{{ $i18nUtil.trans("message.password.valid.error.005", "* 사용할 수 있는 비밀번호 입니다.") }}</div>
                        <!-- </div> -->
                    </div>
                    <div class="input-box">
                        <input autocomplete="off" type="password" id="confirmPassword" name="confirmPassword" v-model="confirmPassword" @keyup="confirmpassword" ref="pw2" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.password.confirm', '비밀번호 확인')" maxlength="10">
                        <!-- <div class="error-list"> -->
                            <div class="error" v-if="errors.has('confirmPassword')">{{ $i18nUtil.trans("message.password.valid.error.001", "* 비밀번호를 입력하세요.") }}</div>
                            <div class="normal" v-if="isPasswordSame === true">{{ $i18nUtil.trans("message.Join.004", "* 신규 비밀번호와 일치합니다.") }}</div>
                            <div class="error" v-if="isPasswordSame === false">{{ $i18nUtil.trans("message.Join.005", "* 신규 비밀번호와 일치하지 않습니다.") }}</div>
                        <!-- </div> -->
                    </div>
                    <div class="input-box">
                        <input autocomplete="off" type="tel" id="cellPhoneNo" name="cellPhoneNo" v-model="cellPhoneNo" @keyup="autoHypenPhone" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.phoneNumber', '휴대폰번호')" >
                        <!-- <div class="error-list"> -->
                            <div class="error" v-if="errors.has('cellPhoneNo') ">{{ $i18nUtil.trans("message.Join.006", "* 휴대폰번호를 입력하세요.") }}</div>
                        <!-- </div> -->
                        <button type="button" class="btn-primary-small black" @click="requestOtp">{{ $i18nUtil.trans("button.send", "전송") }}</button>
                    </div>
                    <!-- <p>인증번호  :  {{ resOtp }}</p>
                        <br><br> -->
                    <div class="input-box">
                        <input autocomplete="new-password" type="number" id="otp" name="otp" v-model="otp" :placeholder="$i18nUtil.trans('message.placeholder.otp', '인증번호')" v-validate="'required'" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                        <!-- <div class="error-list"> -->
                            <div class="error" v-if="errors.has('otp')">* {{ $i18nUtil.trans("message.otp.valid.error.001", "인증번호를 입력하세요.") }}</div>
                        <!-- </div> -->
                        <span class="time" v-if="countDown !== null">
                            <span>{{countDown}}</span>
                        </span>
                    </div>
                    <div class="txtl">
                        <input type="checkbox" id="isConfirm" name="isConfirm" v-model="isConfirm" v-validate="'required'">
                        <label for="isConfirm" v-if="$i18nUtil.getLanguage() === 'ko'" @click="showTermsPop" v-html="$i18nUtil.trans('message.Join.007', '<b>이용약관/개인정보 취급방침</b>에 동의합니다.')"></label>
                        <label for="isConfirm" v-if="$i18nUtil.getLanguage() !== 'ko'" @click="showTermsPop" v-html="$i18nUtil.trans('message.Join.012', '<b>이용약관</b>에 동의합니다.')"></label>
                        <!-- <div class="error-list"> -->
                            <!-- <div class="error" v-if="errors.has('isConfirm') ">* 이용약관/개인정보 취급방침에 동의해주세요.</div> -->
                        <!-- </div> -->
                    </div>
                    <button type="button" class="btn_login" @click="join">{{ $i18nUtil.trans("button.join", "회원가입") }}</button>
                </fieldset>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex";
import LoginLeft from "../../login/base/LoginLeft";
import TermsAndPolicy from "../modal/TermsAndPolicy";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    components : {
        LoginLeft
    },
    data() {
        return {
            show : false,

            /* 협력사 리스트 */
            partnerList : null,

            /* 회원 가입 정보 */
            otp : "",
            otpId : null,
            email : null,
            userName : null,
            password : "",
            isConfirm : false,
            cellPhoneNo : "",
            partnerName : "",
            confirmPassword : "",
            isPasswordSame : null,
            encId : null,  /* 암호화된 email */
            enProjectId : null, /* 암호화된 projectId */

            /* 비밀번호 유효성 체크 */
            time : null,
            timer : null,
            resOtp : null,
            validStep1 : null,
            validStep2 : null,
            validStep3 : null,
            validStep4 : null,
            confirmPw : null,
            validConfirmPw : null,
            isValidPassword : null,
            selectCompanyId : null,
        }
    },
    created () {
        this.handleInit();
    },    
    mounted() {
        // let elements = document.querySelectorAll('[autocomplete="off"]');
        //     elements.forEach(element => {
        //         element.setAttribute("readonly", "readonly");
        //         element.style.backgroundColor = "inherit";
        //         setTimeout(() => {
        //             element.removeAttribute("readonly");
        //         }, 500);
        // })
        /* 이메일 복호화 및 초대 대상 정보 조회 */
        this.init() ;
    },
    watch : {
        // partnerName : function() {
        //     console.log(this.partnerName)
        //     this.getPartnerList();
        // }
    },
    computed : {
        countDown() {
            let time = this.time / 60;
            let minutes = parseInt(time);
            let secondes = Math.round((time - minutes) * 60);

            let min = minutes;
            let sec = secondes;
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + " : " + sec;
        }
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 포달 팝업 */
        ...mapActions("modals", ["showModal"]),
        /* 토스트 알림 호출 */
        ...mapActions("modals", ["showToast"]),
        /* 공통 알림 dialog */
        ...mapActions("modals", ["showDialog"]),
        /* 비밀번호 유효성 검사 */
        ...mapActions("chkPw", ["chkValidPw"]),
        /* 이메일 복호화 및 초대 대상 정보 조회 */
        handleInit() {
            let obj = this;
            /* 다국어 설정(브라우저 언어 별) */
            let locale = navigator.language || navigator.userLanguage;
            locale = locale.substring(0, 2);
            if (locale !== "ko") {
                locale = "en";
            }
            localStorage.setItem('defaultLanguage', locale);
            obj.$i18n.locale = locale;
        },
        init() {
            let obj = this;
            obj.encId = obj.$router.history.current.query.eParam;
            obj.enProjectId = obj.$router.history.current.query.pParam;
            let reqData = {
                url : '/api/auth/org/getInviteUserInfo',
                method : 'post',
                params : {
                    encId : obj.encId,
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                if(errorCode != null) {
                    let contents = null;
                    let info = {
                        title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                        button: obj.$i18nUtil.trans("button.confirm", "확인"),
                        contents : contents
                    };
                    if(errorCode === "AUTH_ORG_ENC_EXPIRED") {
                        info.contents = obj.$i18nUtil.trans("message.Join.008", "이메일 인증기간이 만료되었습니다."); // "이메일 인증기간이 만료되었습니다.";
                        obj.handleDialog(info);
                    }
                } else {
                    if(res.result !== null) {
                        obj.email = res.result.email;
                        obj.userName = res.result.userName;
                    }
                }
            })
            .catch(function (err) {
                console.log(err)
            });
        },
        /* 비밀번호 유효성 검사 */
        async passWordValidation() {
            let obj = this;
            obj.validStep1 = null;
            obj.validStep2 = null;
            obj.validStep3 = null;
            obj.validStep4 = null;

            let pw = obj.password;
            let pwLen = null;
            if(pw != null) {
                pwLen = pw.length;
            }
             
            obj.isValidPassword = false;

            if (pw == "" || pw == 0 || pw == null || pw == undefined) {
                /* 
                chrome 에서는 alert 과 focus 를 동시에 사용시 무한루프가 발생되어 
                해결하기 위해 setTimeout 사용 
                */
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep1 = false;
                return;
            } else {
                obj.validStep1 = true;
            }
            
            if (pwLen < 8 || pwLen > 10) {
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep2 = false;
                return;
            } else {
                obj.validStep2 = true;
            }
            /* 
                패스워드 유효성 검사 
                : 영문 / 숫자 / 특수문자 체크  
            */
            let isValid = await obj.chkValidPw(pw).then((chkVal) => {
                return chkVal;
            });
            if (!isValid) {
                obj.validStep2 = false
                return;
            } else {
                obj.validStep2 = true;
            }
        },
        /* 신규 비밀번호 일치 확인 */
        confirmpassword() {
            let newPw = this.password;
            let chkPw = this.confirmPassword;
            if(chkPw !== null) {
                this.validConfirmPw = true;
                if (newPw !== chkPw) {
                    this.isPasswordSame = false;
                } else {
                    this.isPasswordSame = true;
                }
            } else {
                this.validConfirmPw = false;
            }
        },
        /* 협력업체 리스트 조회 */
        getPartnerList(event) {
            if(this.show === false) {
                event.target.parentElement.classList.toggle('active');
                this.show = true;
            }
            let obj = this;
            let reqData = {
                url : '/api/auth/org/getPartnerList',
                method : 'post',
                params : {
                    partnerName : obj.partnerName
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                if(errorCode != null) {
                    console.log(errorCode)
                } else {
                    let companyName = [];
                    let companyId = null;
                    let list = res.result;
                    list.forEach(arg => {
                        companyName.push(arg.substring(0,arg.indexOf(",")));
                        companyId = arg.substring(arg.indexOf(",")+1);
                    });
                    obj.selectCompanyId = companyId;
                    obj.partnerList = companyName;
                }
            })
            .catch(function (err) {
                console.log(err)
            });
        },
        /* 협력업체 선택시 */
        selectPartner(partnerName) {
            this.show = false;
            this.partnerName = partnerName;
            document.getElementById('partnerArea').classList.toggle('active');
        },
        hidePartnerList() {
            this.show = true;
        },
        /* 협력업체 신규 추가 */
        addPartner() {
            let obj = this;
            let reqData = {
                url : '/api/auth/org/addPartner',
                method : 'post',
                params : {
                    partnerName : obj.partnerName
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                obj.partnerList = null;
                obj.partnerName = "";
                if(errorCode != null) {
                    console.log(errorCode)
                } else {
                    let toastInfo = {
                    obj: obj.$toasted,
                    message: obj.$i18nUtil.trans("message.Join.009", "소속회사에 {partner}가 추가되었습니다.", {partner: obj.partnerName}), // "소속회사에 " + this.partnerName + " 가 추가되었습니다.",
                    options: {
                        theme: "toasted-primary",
                        position: "bottom-right",
                        duration: 3000,
                    }
                    };
                    obj.showToast(toastInfo);
                    obj.show = false;
                    document.getElementById("partnerArea").classList.toggle('active');
                }
            })
            .catch(function (err) {
                console.log(err)
            });
        },
        autoHypenPhone() {
            let str = this.cellPhoneNo.replace(/[^0-9]/g, '');
            let tmp = '';
            if( str.length < 4){
                this.cellPhoneNo = str;
                return;
            }else if(str.length < 7){
                tmp += str.substr(0, 3);
                tmp += '-';
                tmp += str.substr(3);
                this.cellPhoneNo = tmp;
                return;
            }else if(str.length < 11){
                tmp += str.substr(0, 3);
                tmp += '-';
                tmp += str.substr(3, 3);
                tmp += '-';
                tmp += str.substr(6);
                this.cellPhoneNo = tmp;
                return;
            }else{              
                tmp += str.substr(0, 3);
                tmp += '-';
                tmp += str.substr(3, 4);
                tmp += '-';
                tmp += str.substr(7);
                this.cellPhoneNo = tmp;
                return;
            }
            this.cellPhoneNo = tmp;
        },
        async requestOtp() {
            let obj = this;
            let valid_1 = null;
            let valid_2 = null;
            let valid_3 = null;
            let valid_4 = null;
            if(await obj.$validator.validate('email')) {
                valid_1 = await obj.$validator.validate('email');
            }
            if(await obj.$validator.validate('userName')) {
                valid_2 = await obj.$validator.validate('userName');
            }
            if(await obj.$validator.validate('partnerName')) {
                valid_3 = await obj.$validator.validate('partnerName');
            }
            if(await obj.$validator.validate('cellPhoneNo')) {
                valid_4 = await obj.$validator.validate('cellPhoneNo');
            }
            if(valid_1 & valid_2 & valid_3 & valid_4) {
                let reqData = {
                    url : "/api/auth/org/requestOtp",
                    method : "post",
                    params : {
                        otpKbn  : "JOIN",
                        otp : obj.resOtp,
                        otpId : obj.otpId,
                        userId : obj.email,
                        userName : obj.userName,
                        companyId : "801",
                        cellPhoneNo : obj.cellPhoneNo,
                    }
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function(res) {
                    if(res.errorCode != null) {
                        let errorCode = res.errorCode;
                        console.log(errorCode)
                    } else {
                        let contents = null;
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            button: obj.$i18nUtil.trans("button.confirm", "확인"),
                            contents : obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다.")
                        };
                        obj.handleDialog(info);
                        obj.resOtp = res.result.otp;
                        obj.otpId = res.result.otpId;
    
                        obj.time = 300;
                        obj.handleCountDown();
                        // console.log("OTP 번호 :: "+obj.resOtp);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            }
        },
         /* 5분 카운트 다운 */
        handleCountDown(timer) {
            if(timer !== null) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            }
        },
        /* 이용약관 & 개인정보 취급방침 모달 */
        showTermsPop() {
            const modalInfo = {
                width: "800px",
                height: "520px",
                obj: this.$modal,
                component: TermsAndPolicy,
            };
            this.showModal(modalInfo);
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
        /* 외부사용자 회원가입 */
        join() {
            if (this.time === 0) {
                let info = {
                    title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                    contents: this.$i18nUtil.trans("AG015", "인증번호 입력시간이 초과되었습니다.\n인증번호 재전송 후 다시 입력해주세요."),
                    button: this.$i18nUtil.trans("button.confirm", "확인")
                };
                this.handleDialog(info);
            } else {
                let obj = this;
                if(!isConfirm) {
                    let msg = this.$i18nUtil.getLanguage() === 'ko' ?
                             this.$i18nUtil.trans("AG043", "이용약관/개인정보 처리방침에 동의하셔야 가입이 가능합니다.")
                             : this.$i18nUtil.trans("AG043.001", "이용약관에 동의하셔야 가입이 가능합니다.")
                    let info = {
                        title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                        contents: msg,
                        button: this.$i18nUtil.trans("button.confirm", "확인")
                    };
                    obj.handleDialog(info);
                    return;
                }
                obj.$validator.validate().then((valid) => {
                    if (valid) {
                        if (obj.password === obj.confirmPassword) {
                            let reqData = {
                            url: "/api/auth/org/join",
                            method: "post",
                                params: {
                                    otp : obj.otp,
                                    encId: obj.encId,
                                    otpId : obj.otpId,
                                    password: obj.password,
                                    userName: obj.userName,
                                    cellPhoneNo: obj.cellPhoneNo,
                                    partnerName: obj.partnerName,
                                    enProjectId : obj.enProjectId,
                                    selectCompanyId : obj.selectCompanyId,
                                },
                            };
                            obj
                            .COWORK_REST_SIMPLE_ACTION(reqData)
                            .then(function (res) {
                                console.log(res);
                                if(res !== null && res !== undefined) {
                                    if (res.errorCode !== null && res.errorCode !== undefined) {
                                        let errorCode = res.errorCode;
                                        if(errorCode === "AG017") {
                                            let info = {
                                                title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                                                contents: this.$i18nUtil.trans("AG017", "인증번호가 일치하지 않습니다.\n인증번호를 확인 후 다시 시도해주세요."),
                                                button: this.$i18nUtil.trans("button.confirm", "확인")
                                            };
                                            obj.handleDialog(info);
                                        } else if(errorCode === "AUTH_ORG_EMAIL_EXPIRED") {
                                            alert(obj.$i18nUtil.trans("message.Join.010", "가입 유효 기간이 만료되었습니다.")) // "가입 유효 기간이 만료되었습니다."
                                        } else if(errorCode === "UB034") {
                                            let info = {
                                                title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                                                contents: this.$i18nUtil.trans("UB034", "전화번호와 동일하여 사용할 수 없습니다."),
                                                button: this.$i18nUtil.trans("button.confirm", "확인")
                                            };
                                            obj.handleDialog(info);
                                        } else if(errorCode === "AUTH_ORG_NO_INVITE_INFO") {
                                            alert(obj.$i18nUtil.trans("message.Join.011", "시스템 초대 정보가 없습니다.")); // "시스템 초대 정보가 없습니다."
                                            let info = {
                                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                                contents: obj.$i18nUtil.trans("message.Join.011", "시스템 초대 정보가 없습니다."), // "시스템 초대 정보가 없습니다.",
                                                button: obj.$i18nUtil.trans("button.confirm", "확인")
                                            };
                                            obj.handleDialog(info);
                                        }
                                    } else {
                                        if(res.result != null) {
                                            if(res.result) {
                                                obj.$router.push("/login");
                                            } else {
                                                obj.$router.push("/approvalNoti");
                                            }
                                        }
                                    }
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                        } else {
                            alert(obj.$i18nUtil.trans("UB041", "비밀번호가 일치하지 않습니다.")); // "비밀번호가 일치하지 않습니다."
                        }
                    }
                });
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/join/base/Join.vue